module.exports = __webpack_public_path__ + "static/img/logo.831cde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 10